import { Button } from '@material-ui/core';
import React from 'react';
import { FILES_PAGE } from '../../constants';
import history from '../../history';
import { NotificationTableRowData } from './InboxContent';

interface NotificationTableActionRendererProps {
  data: NotificationTableRowData;
}

export const NotificationTableActionRenderer = (
  props: NotificationTableActionRendererProps,
) => {
  const {
    data: { channelId, location, isDeleted },
  } = props;

  // hide the 'view' action button
  // when isDeleted is true
  const hideAction = isDeleted;

  const filePathParts = location
    .split('/')
    .filter((part: string) => part !== '');

  const baseUrl = `${FILES_PAGE.path}?channelId=${channelId}`;

  const handleClick = () => {
    let url = baseUrl;

    if (filePathParts && filePathParts.length > 0) {
      url = `${baseUrl}&selectedFilePath=${encodeURIComponent(location)}`;
    }

    history.push(url);
  };

  if (hideAction) return null;

  return (
    <Button
      variant="contained"
      color="secondary"
      className="notification-table-action"
      onClick={handleClick}
      data-testid="notification-table-action"
    >
      View
    </Button>
  );
};
